// import Progress0 from 'assets/images/circular-progress/progress_0.png';
// import Progress1 from 'assets/images/circular-progress/progress_1.png';
// import Progress2 from 'assets/images/circular-progress/progress_2.png';
// import Progress3 from 'assets/images/circular-progress/progress_3.png';
// import Progress4 from 'assets/images/circular-progress/progress_4.png';
// import Progress5 from 'assets/images/circular-progress/progress_5.png';
// import Progress6 from 'assets/images/circular-progress/progress_6.png';
// import Progress7 from 'assets/images/circular-progress/progress_7.png';
// import Progress8 from 'assets/images/circular-progress/progress_8.png';
// import Progress9 from 'assets/images/circular-progress/progress_9.png';
// import Progress10 from 'assets/images/circular-progress/progress_10.png';

export const getImgBasedOnScore = (score: number) => {
  switch (true) {
    case score === 0:
      return require(`assets/images/circular-progress/progress_0.png`);
    case score > 0 && score < 10:
      return require(`assets/images/circular-progress/progress_1_9.png`);
    case score >= 10 && score < 20:
      return require(`assets/images/circular-progress/progress_1.png`);
    case score >= 20 && score < 30:
      return require(`assets/images/circular-progress/progress_2.png`);
    case score >= 30 && score < 40:
      return require(`assets/images/circular-progress/progress_3.png`);
    case score >= 40 && score < 50:
      return require(`assets/images/circular-progress/progress_4.png`);
    case score >= 50 && score < 60:
      return require(`assets/images/circular-progress/progress_5.png`);
    case score >= 60 && score < 70:
      return require(`assets/images/circular-progress/progress_6.png`);
    case score >= 70 && score < 80:
      return require(`assets/images/circular-progress/progress_7.png`);
    case score >= 80 && score < 90:
      return require(`assets/images/circular-progress/progress_8.png`);
    case score >= 90 && score < 100:
      return require(`assets/images/circular-progress/progress_9.png`);
    case score >= 100:
      return require(`assets/images/circular-progress/progress_10.png`);
    default:
      return '';
  }
};

export default function CircularProgress({ score }: { score: number }) {
  let imgSrc = getImgBasedOnScore(score);

  return (
    <div className='relative'>
      <img
        src={imgSrc}
        alt={`score-progress-${score}`}
        className='object-cover w-full h-full'
      />
      <p className='absolute text-2xl font-semibold text-white transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2'>
        {score}
      </p>
    </div>
  );
}
